export default __webpack_public_path__ + "static/media/visitor.5e4e2186.svg";